import { render, staticRenderFns } from "./banner_layout.vue?vue&type=template&id=11f38eed&scoped=true&"
import script from "./banner_layout.vue?vue&type=script&lang=js&"
export * from "./banner_layout.vue?vue&type=script&lang=js&"
import style0 from "./banner_layout.vue?vue&type=style&index=0&id=11f38eed&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f38eed",
  null
  
)

export default component.exports